import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@snipit/core/context/AuthContext';
import GeminiReviewView from '@snipit/ui/components/GeminiReviewView';

const WebGeminiReviewView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userLicense } = useAuth();
  
  // Route protection - verify user is an enterprise tier
  if (userLicense?.tier !== 'enterprise' && userLicense?.tier !== 'enterprise_org') {
    return <Navigate to="/vault" replace />;
  }

  const handleBack = () => {
    navigate('/vault');
  };

  return (
    <GeminiReviewView
      initialCode={location.state?.code}
      initialLanguage={location.state?.language}
      onBack={handleBack}
    />
  );
};

export default WebGeminiReviewView;
